
import {
  SELECT_TRANSCRIPTS,
  DESELECT_TRANSCRIPT,
  SET_TOTAL_COUNT,
  SET_SELECTED_TRANSCRIPT_FOR_PREVIEW,
  HIDE_SELECTED_TRANSCRIPT,
  SHOW_SELECTED_TRANSCRIPT,
  ON_REMOVED_TRANSCRIPTS,
  FILE_FOR_PREVIEW_START_DOWNLOAD,
  FILE_FOR_PREVIEW_WAS_DOWNLOAD,
} from './transcriptViewerActions'
import { FIRST_START, LOGIN_BY_PARAMETERS_FROM_URL } from '../../store/actions/appActions'
import { LOGIN } from '../login/loginActions'

export const initialState = {
  selectionFilter: [],
  preview: {
    transcript: undefined,
    media: {
      linksFromBlobByURL: {},
      urlsAlreadyDownloading: {},
    },
  },
  lastClickTimeSelectAll: undefined,
  isHideSelectedTranscript: false,
  totalCount: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FIRST_START:
      return { ...state }
    case SET_TOTAL_COUNT:
      return { ...state, totalCount: Number(payload) }
    case FILE_FOR_PREVIEW_START_DOWNLOAD:
      return {
        ...state,
        preview: {
          ...state.preview,
          media: {
            ...state.preview.media,
            urlsAlreadyDownloading: { ...state.preview.media.urlsAlreadyDownloading, [payload]: true },
          },
        },
      }
    case FILE_FOR_PREVIEW_WAS_DOWNLOAD:
      return {
        ...state,
        preview: {
          ...state.preview,
          media: {
            ...state.preview.media,
            linksFromBlobByURL: { ...state.preview.media.linksFromBlobByURL, ...payload },
          },
        },
      }

    /* selectedTranscripts */
    case SELECT_TRANSCRIPTS:
      return {
        ...state,
        selectionFilter: payload.selectionFilter,
        lastClickTimeSelectAll: payload.lastClickTimeSelectAll,
        isHideSelectedTranscript: false,
      }
    case DESELECT_TRANSCRIPT:
    case ON_REMOVED_TRANSCRIPTS:
    case LOGIN:
    case LOGIN_BY_PARAMETERS_FROM_URL:
      return {
        ...state,
        selectionFilter: initialState.selectionFilter,
        preview: initialState.preview,
        lastClickTimeSelectAll: initialState.lastClickTimeSelectAll,
      }
    case HIDE_SELECTED_TRANSCRIPT:
      return { ...state, isHideSelectedTranscript: true }
    case SHOW_SELECTED_TRANSCRIPT:
      return { ...state, isHideSelectedTranscript: false }
    case SET_SELECTED_TRANSCRIPT_FOR_PREVIEW:
      return { ...state, preview: { transcript: payload, media: initialState.preview.media } }

    default:
      return state
  }
}
